module.exports = __webpack_public_path__ + "media/images/product/m_a-b284d655a4a78c9646ee62aaab4a4a25.png";